import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { ContentUnitNavigationItem } from '@app/layout/sidebar/models/content-unit-navigation-item.model'
import { Tag } from 'primeng/tag'
import { TemplateSidebarBridgeService } from '@features/template/services/template-sidebar-bridge.service'
import { CommonModule } from '@angular/common'
import { ButtonDirective } from 'primeng/button'

@Component({
  selector: 'albert-list-view-cu-list-item',
  imports: [
    RouterLinkActive,
    RouterLink,
    Tag,
    CommonModule,
    ButtonDirective
  ],
  templateUrl: './list-view-cu-list-item.html',
  styleUrl: './list-view-cu-list-item.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewCuListItem {
  public readonly itemClicked = output()
  public readonly item = input.required<ContentUnitNavigationItem>()

  protected readonly bridgeService = inject(TemplateSidebarBridgeService)

  public readonly isEditMode = this.bridgeService.isTemplateEditMode
  public readonly isUsed = computed(() =>
    this.bridgeService.usedContentUnitUuids().includes(this.item().uuid)
  )

  public onEntryClick(): void {
    if (this.isEditMode()) {
      return
    }
    this.itemClicked.emit()
  }

  public onAddClick(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    if (!this.isUsed()) {
      this.bridgeService.addContentUnit(this.item())
    }
  }

}
